<template>
  <button class="uk-button uk-border-rounded uk-button-small" :class="{ 'uk-button-default': !isChecked, 'button-success': isChecked }" @click.prevent="addToFavorites">
    <div class="uk-flex uk-flex-middle">
      <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" :fill="fill" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      &nbsp;
      <span>{{ label }}</span>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    carId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentValues: [],
    }
  },

  mounted() {
    this.currentValues = JSON.parse(localStorage.getItem('webkfz:favorites')) || []
  },

  computed: {
    isChecked() {
      return this.currentValues.includes(this.carId)
    },
    fill() {
      return this.isChecked ? 'currentcolor' : 'none'
    },
    label() {
      return this.isChecked ? 'Geparkt' : 'Parken'
    },
  },

  methods: {
    addToFavorites() {
      this.currentValues = JSON.parse(localStorage.getItem('webkfz:favorites')) || []
      if (this.currentValues.includes(this.carId)) {
        this.currentValues.splice(this.currentValues.indexOf(this.carId), 1)
        this.$emit('removed', this.carId)
      } else {
        this.currentValues.push(this.carId)
      }
      localStorage.setItem('webkfz:favorites', JSON.stringify(this.currentValues))
      this.$emit('updated', this.currentValues)
    },
  },
}
</script>
